import { Button, Col, Modal, Row, Select, Icon } from 'antd';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import lang from './../../../../../languages/en';
import { onChangePackageInfo, onOk, onSubmit, submitPackageInfo } from './../../../../../actions/shipmentAction';
import InputFormat from './../../../../../components/input-format';
import { getShipmentParams } from './../../../../../services/helper';
import { ServiceType } from './../../../../../constants/index';
import { ListChannel } from './../../../../../constants/setting_channel';
import './styles.css';
const confirm = Modal.confirm;
const Option = Select.Option
let Max = {
    kgm: 25,
    lbs: 55,
    cm: 160,
    inch: 63,
}

class AddPackageInfor extends Component {
    shouldComponentUpdate(nextProps) {
        switch (nextProps.package_info.st) {
            case "H":
                Max = {
                    kgm: 125,
                    lbs: 276,
                    cm: 450,
                    inch: 178,
                };
                break;
            case "M":
                Max = {
                    kgm: 1,
                    lbs: 2.2,
                    cm: 56.5,
                    inch: 22.2,
                };
                break;
            case "K":
                Max = {
                    kgm: 25,
                    lbs: 55,
                    cm: 160,
                    inch: 63,
                };
                break;
        }
        return true;
    }
    confirmAddPackage = () => {
        let _this = this
        confirm({
            title: lang.confirm_add_package,
            autoFocusButton: null,
            content: (
                <div>
                    {this.props.package_info.pgw ? <span>Gross Weight: {this.props.package_info.pgw} &nbsp;{this.props.package_info.pgw_unit}<br /></span> : null}
                    {
                        (this.props.package_info.l && this.props.package_info.w && this.props.package_info.h) ?
                            <div>
                                <span>Length: {this.props.package_info.l} &nbsp;{this.props.package_info.lwh_unit}<br /></span>
                                <span>Width: {this.props.package_info.w} &nbsp;{this.props.package_info.lwh_unit}<br /></span>
                                <span>Height: {this.props.package_info.h} &nbsp;{this.props.package_info.lwh_unit}<br /></span>
                            </div> : ""

                    }
                    {this.props.package_info.pvw ? <span style={{"display":
                        (this.props.package_info.crkc
                            || this.props.package_info.crki
                            || this.props.package_info.crlc
                            || this.props.package_info.crli) ? "block" : "none"}}>Volume Weight: {this.props.package_info.pvw} &nbsp;{this.props.package_info.pgw_unit}<br /></span> : null}
                    {this.props.package_info.st ? <span>Service Type: {ServiceType[this.props.package_info.st]}<br /></span> : null}
                    {(this.props.package_info.l && this.props.package_info.w && this.props.package_info.h) ? "" : <h3>Will not save incomplete dimension information.</h3>}
                    <span className='confirm-add-package'>{lang.warning_add_package}</span>
                </div>
            ),
            onOk() {
                _this.props.submitPackageInfo({
                    ids: _this.props.listIdCheckedShipments,
                    value: _this.props.package_info
                })
            },
            onCancel() { },
        });
    }

    displayMessageError = (obj, type) => {
        let result = false
        if (type === 'weight') {
            if (obj.pgw_unit === 'LBS' && parseFloat(obj.pgw).toFixed(1) > Max.lbs) {
                result = true
            } else if (obj.pgw_unit === 'KGS' && parseFloat(obj.pgw).toFixed(1) > Max.kgm) {
                result = true
            }
        } else if (type === 'lwh') {
            if (obj.lwh_unit === 'INCH' && (parseFloat(obj.l) + parseFloat(obj.w) + parseFloat(obj.h)).toFixed(1) > Max.inch) {
                result = true
            } else if (obj.lwh_unit === 'CM' && (parseFloat(obj.l) + parseFloat(obj.w) + parseFloat(obj.h)).toFixed(1) > Max.cm) {
                result = true
            }
        }
        return result
    }

    checkAddInfoPackageObj = (obj) => {
        let result = false
        for (let key in obj) {
            if (!obj[key]) {
                result = true
            }
        }
        if (obj.pgw) {
            result = false
        } else {
            if (obj.l && obj.w && obj.h) {
                if (obj.pgw === 0) {
                    result = true
                } else result = false
            }
        }

        if (obj.pgw_unit === 'LBS' && parseFloat(obj.pgw).toFixed(1) > Max.lbs) {
            result = true
        } else if (obj.pgw_unit === 'KGS' && parseFloat(obj.pgw).toFixed(1) > Max.kgm) {
            result = true
        }
        if (obj.lwh_unit === 'INCH' && (parseFloat(obj.l) + parseFloat(obj.w) + parseFloat(obj.h)).toFixed(1) > Max.inch) {
            result = true
        } else if (obj.lwh_unit === 'CM' && (parseFloat(obj.l) + parseFloat(obj.w) + parseFloat(obj.h)).toFixed(1) > Max.cm) {
            result = true
        }
        return result
    }

    renderTransmitedMessage = () => {
        let { IsTransmitAuto, IsSuccess, Message, Channels } = this.props.transmited_success_data;
        let contentTransmited = "";
        if (IsSuccess) {
            contentTransmited = (
                <div>
                    <p class="rt-transmit-title">{lang.transmit_shipment_success_line_1}</p>
                    <p>{lang.transmit_shipment_success_line_2}</p>
                    <p>{lang.transmit_shipment_success_line_3}</p>
                </div>
            );

        } else {
            let contentMessageTransmitFails = [];
            let key;
            let flag_not_complete = false; 
            for (key in Channels) {
                let itemChannel = Channels[key];
                if (!itemChannel.IsSuccess) {
                    if (itemChannel.Code === 311807 || itemChannel.Code === 311809 ) {
                        flag_not_complete = true
                    }
                    contentMessageTransmitFails.push(itemChannel.Message);
                    break;
                }
                
            }
           
            
            if (flag_not_complete) {
                contentTransmited = (
                    <div class="rt-transmit-error rt-transmit-warning">
                        <p class="rt-transmit-title"> <Icon type="exclamation-circle" className="icon-warning-transmit" /><span>{lang.transmit_shipment_not_completed}</span></p>
                        {contentMessageTransmitFails.length > 0 ? <p class="rt-transmit-content" dangerouslySetInnerHTML={{ __html: contentMessageTransmitFails[0] }}>{}</p> : ''}
                    </div>
                );
            } else {
                contentTransmited = (
                    <div class="rt-transmit-error">
                        <p class="rt-transmit-title"><Icon type="close-circle" /><span>{lang.transmit_shipment_fails}</span></p>
                        {contentMessageTransmitFails.length > 0 ? <p class="rt-transmit-content" dangerouslySetInnerHTML={{ __html: contentMessageTransmitFails[0] }}>{}</p> : ''}
                    </div>
                );
            }
            
        }
        return (
            <div class="box-item-result-transmit">{contentTransmited}</div>
        )

    }

    render() {
        if(!this.props.package_info.shiper_st){
        Max = {
                kgm: 25,
                lbs: 55,
                cm: 160,
                inch: 63,
              };
        this.props.package_info.st = 'K';
        }
        let disableSubmit = this.checkAddInfoPackageObj(this.props.package_info)
        let maxPGW
        let maxLWH
        if (this.props.package_info.pgw_unit == 'KGS') {
            maxPGW = Max.kgm + ' kg.'
        } else if (this.props.package_info.pgw_unit == 'LBS') {
            maxPGW = Max.lbs + ' lbs.'
        }
        if (this.props.package_info.lwh_unit == 'CM') {
            maxLWH = Max.cm + ' cm.'
        } else if (this.props.package_info.lwh_unit == 'INCH') {
            maxLWH = Max.inch + ' in.'
        }
        let listOptionServiceType = Object.keys(ServiceType).map((key) => {
            return <Option value={key} key={key}>{ServiceType[key]}</Option>
        })

        let contentTransmited = "";
        let widthModalTransmit = 700;
        if (this.props.transmited_success && this.props.transmited_success_data) {
            if (!this.props.transmited_success_data.IsSuccess) {
                widthModalTransmit = 600;
            }
            contentTransmited = this.renderTransmitedMessage();
        }

        return (
            <div>
                <Modal
                    visible={this.props.error_package_info_has_info}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_error_package_info_has_info" type="primary" onClick={() => this.props.onOk('add_failure')}>OK</Button>,
                    ]}
                >
                    <p>{lang.package_infor_already_exist}</p>
                    <p>{lang.confirm_overwrite_package}</p>
                </Modal>
                <Modal
                    visible={this.props.error_package_info_cannot_edit}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_error_package_info_cannot_edit" type="primary" onClick={() => this.props.onOk('add_failure')}>OK</Button>,
                    ]}
                >
                    <p>{lang.cannot_add_package_info_transmit}</p>
                </Modal>
                <Modal
                    visible={this.props.add_package_info_success}
                    closable={false}
                    footer={[
                        <Button
                            key="ok_add_package_info_success"
                            type="primary"
                            onClick={() => {
                                this.props.onOk('add_success')
                                this.props.onSubmit({ ...this.props.getShipmentParams, SelectedIds: [], Page: 1 })
                            }}
                        >OK</Button>,
                    ]}
                >
                    <p>{lang.add_package_infor_success}</p>
                </Modal>
                <Modal
                    visible={this.props.add_package_info_failure}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_create_shipment_failure" type="primary" onClick={() => this.props.onOk('add_failure')}>OK</Button>,
                    ]}
                >
                    <p>{lang.add_package_fails}</p>
                </Modal>
                <Modal
                    visible={this.props.delete_shipment_success}
                    closable={false}
                    footer={[
                        <Button
                            key="ok_modal_delete_shipment_success"
                            type="primary"
                            onClick={() => {
                                this.props.onOk('delete')
                                this.props.onSubmit({ ...this.props.getShipmentParams, Page: 1, SelectedIds: [] })
                            }}
                        >OK</Button>,
                    ]}
                >
                    <p>{lang.delete_shipment_success}</p>
                </Modal>
                <Modal
                    visible={this.props.transmited_success}
                    closable={false}
                    width={widthModalTransmit}
                    className="rt-modal-transmit-sucess"
                    footer={[
                        <Button
                            key="ok_modal_transmited_shipment_success"
                            type="primary"
                            onClick={() => {
                                this.props.onOk('trasmitted')
                                this.props.onSubmit({ ...this.props.getShipmentParams, Page: 1, SelectedIds: [] })
                            }}
                        >
                            OK
                        </Button>,
                    ]}
                >
                    <div>{contentTransmited}</div>
                </Modal>
                <Modal
                    visible={this.props.transmited_failure}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_transmited_shipment_failure"
                            type="primary" onClick={() => this.props.onOk('trasmitted')}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>{lang.transmit_shipment_fails}</p>
                </Modal>
                <Modal className="add-info-modal add-package-information"
                    visible={this.props.add_package_info}
                    title={
                        <div className="top-add-info">
                            <span>Enter Package Information</span>
                        </div>
                    }
                    closable={false}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={
                        <div className='footer-add-info'>
                            <div className='btn-footer'>
                                <Button key="back" className="cancel-btn"
                                    onClick={() => { this.props.onOk('close-add-package') }}
                                >Cancel</Button>
                                <Button key="submit" className="save-btn ant-btn-primary" loading={this.props.on_submit_package_info}
                                    disabled={disableSubmit}
                                    onClick={() => {
                                        this.confirmAddPackage()
                                    }}>SAVE</Button>
                            </div>
                        </div>
                    }
                >
                    <div className="body-add-info">
                        <p>Enter Package Information</p>
                        <p className="shipment-applied">{lang.shipment_applied}</p>
                        <Row gutter={8} className="title-add-info">
                            <Col span={8}>
                                <span>
                                    Package Gross Weight:
                                </span><br />
                                <small>( Maximum : {maxPGW}) </small>
                            </Col>
                            <Col span={4}>
                                <InputFormat className="title-add-info-col" decimal={[5, 1]} isRedstar={false} min={0}
                                    value={this.props.package_info.pgw}
                                    placeholder="GW"
                                    onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'pgw' })}
                                />
                            </Col>
                            <Col span={5}>
                                <Select className="title-add-info-col" value={this.props.package_info.pgw_unit}
                                    onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'pgw_unit' })}
                                >
                                    <Option value="LBS">LBS</Option>
                                    <Option value="KGS">KGS</Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} offset={8} style={{
                                display: this.displayMessageError(this.props.package_info, 'weight') ? 'block' : 'none'
                            }}>
                                <small style={{ color: 'red' }}>{lang.enter_valid_weight}</small><br />
                                <small style={{ color: 'red' }}>{lang.weight_add_package_error} {maxPGW}</small>
                            </Col>
                        </Row>
                        <Row gutter={8} className="title-add-info">
                            <Col span={8}>
                                <span>
                                    Package Dimensions:
                                </span><br />
                                <small>( Maximum L+W+H: {maxLWH}) </small>
                            </Col>
                            <Col span={3}>
                                <InputFormat className="title-add-info-col" decimal={[5, 1]} isRedstar={false} min={0} placeholder="L"
                                    value={this.props.package_info.l}
                                    onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'l' })}
                                />
                            </Col>
                            <Col className="plus-icon" span={1}>
                                <span >+</span>
                            </Col>
                            <Col span={3}>
                                <InputFormat className="title-add-info-col" decimal={[5, 1]} isRedstar={false} min={0} placeholder="W"
                                    value={this.props.package_info.w}
                                    onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'w' })}
                                />
                            </Col>
                            <Col className="plus-icon" span={1}>
                                <span>+</span>
                            </Col>
                            <Col span={3}>
                                <InputFormat className="title-add-info-col" decimal={[5, 1]} isRedstar={false} min={0} placeholder="H"
                                    value={this.props.package_info.h}
                                    onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'h' })}
                                />
                            </Col>
                            <Col span={5}>
                                <Select className="title-add-info-col" value={this.props.package_info.lwh_unit}
                                    onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'lwh_unit' })}
                                >
                                    <Option value="INCH">INCH</Option>
                                    <Option value="CM">CM</Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} offset={8} style={{
                                display: this.displayMessageError(this.props.package_info, 'lwh') ? 'block' : 'none'
                            }}>
                                <small style={{ color: 'red' }}>{lang.enter_valid_lwh}</small><br />
                                <small style={{ color: 'red' }}>{lang.lwh_add_package_error} {maxLWH}</small>
                            </Col>
                        </Row>

                        <Row gutter={8} className="title-add-info" style={{"display":
                                (this.props.package_info.crkc
                                    || this.props.package_info.crki
                                    || this.props.package_info.crlc
                                    || this.props.package_info.crli) ? "block" : "none"}}>
                            <Col span={8}>
                                <span>
                                Package Volume Weight:
                                </span><br />
                            </Col>
                            <Col span={4}  style={{"text-align": "right"}}>
                                <span>{this.props.package_info.pvw_display}</span>
                            </Col>
                            <Col span={5}>
                                <span>{this.props.package_info.pgw_unit}</span>
                            </Col>
                        </Row>

                        {

                          this.props.package_info.shiper_st ?
                            <Row gutter={8} className="title-add-info">
                                <Col span={8}>
                                    <span>Service Type:</span>
                                </Col>
                                <Col span={12}>
                                    <Select className="title-add-info-col"
                                        value={this.props.package_info.st}
                                        onChange={(e) => this.props.onChangePackageInfo({ value: e, column: 'st' })}
                                    >
                                        {listOptionServiceType}
                                    </Select>
                                </Col>
                            </Row>
                            : ''
                        }

                    </div>
                </Modal>
                <Modal
                    visible={this.props.clear_feed_success}
                    closable={false}
                    width={widthModalTransmit}
                    className="rt-modal-clear-feed-sucess"
                    footer={[
                        <Button
                            key="ok_modal_clear_feed_success"
                            type="primary"
                            onClick={() => {
                                console.log('ON_OK: clear');
                                this.props.onOk('clear')
                                this.props.onSubmit({ ...this.props.getShipmentParams, Page: 1, SelectedIds: [], SearchTransmitFail: true })
                            }}
                        >
                            OK
                        </Button>,
                    ]}
                >
                    <div>{lang.clear_feed_success}</div>
                </Modal>
                <Modal
                    visible={this.props.clear_feed_failure}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_clear_feed_failure"
                            type="primary" onClick={() => this.props.onOk('clear')}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>{lang.transmit_shipment_fails}</p>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        package_info: state.shipmentReducer.package_info,
        getShipmentParams: getShipmentParams(state),
        listIdCheckedShipments: state.shipmentReducer.listIdCheckedShipments,
        add_package_info: state.shipmentReducer.add_package_info,
        add_package_info_success: state.shipmentReducer.add_package_info_success,
        add_package_info_failure: state.shipmentReducer.add_package_info_failure,
        error_package_info_has_info: state.shipmentReducer.error_package_info_has_info,
        error_package_info_cannot_edit: state.shipmentReducer.error_package_info_cannot_edit,
        delete_shipment_success: state.shipmentReducer.delete_shipment_success,
        transmited_success: state.shipmentReducer.transmited_success,
        transmited_success_data: state.shipmentReducer.transmited_success_data,
        transmited_failure: state.shipmentReducer.transmited_failure,
        clear_feed_success: state.shipmentReducer.clear_feed_success,
        clear_feed_failure: state.shipmentReducer.clear_feed_failure,
        on_submit_package_info: state.shipmentReducer.on_submit_package_info
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        onChangePackageInfo: payload => {
            dispatch(onChangePackageInfo(payload))
        },
        onOk: (payload) => {
            dispatch(onOk(payload))
        },
        submitPackageInfo: payload => {
            dispatch(submitPackageInfo(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddPackageInfor)



// WEBPACK FOOTER //
// ./src/containers/shipments/list/components/add-package-infor/index.js